import { useTranslation } from 'next-i18next';
import { DSHeading, DSLinkButton, DSText } from '@stihl-design-system/components';

import { formatDateStr } from '@phoenix/core/frontend/shared/util/format/dates';
import { link } from '@phoenix/core/frontend/shared/util/navigation/link.utils';

export const RafflePromo = ({ periodStart, periodEnd }) => {
  const { t } = useTranslation();

  return (
    <div className="flex-1 bg-secondary-light content-center tabletOnly:pr-6">
      <div className="p-4 tablet:px-6 desktop:pl-10 desktop:pr-12 pt-8">
        <div className="flex flex-col text-center tablet:flex-none tablet:text-start tablet:block">
          <DSHeading tag="h2" size="large-uppercase" className="text-wrap">
            {t('toolShed_myEquipment_raffleNoProducts_header')}
          </DSHeading>
          <DSText className="mt-2">{t('toolShed_myEquipment_raffleNoProducts_description')}</DSText>
          <DSLinkButton href={link(`/tool-shed/add-tool`)} className="mt-5">
            {t('toolShed_myEquipment_raffleNoProducts_button')}
          </DSLinkButton>
        </div>
        {periodStart && periodEnd && (
          <DSText className="mt-4 text-center tablet:absolute bottom-4" size="x-small">
            {t('toolShed_myEquipment_raffleNoProducts_disclaimer', {
              periodStart: formatDateStr(periodStart),
              periodEnd: formatDateStr(periodEnd),
            })}
          </DSText>
        )}
      </div>
    </div>
  );
};
